import Vue from 'vue';

const Alert = Vue.extend(require('./Main.vue').default);

const Main = {};
// eslint-disable-next-line no-shadow
Main.install = function (Vue, options) {
  if (document.getElementsByClassName('message').length) {
    return;
  }
  const MessageTpl = Vue.extend(Alert);
  const $vm = new MessageTpl();
  // 此处使用$mount来手动开启编译。用$el来访问元素，并插入到body中
  const tpl = $vm.$mount().$el;
  document.body.appendChild(tpl);
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$message = {
    // 控制message显示的方法
    // eslint-disable-next-line no-shadow
    show(options) {
      // 对参数进行判断
      if (typeof options === 'string') {
        // 传入props
        $vm.text = options;
      } else if (typeof options === 'object') {
        // 合并参数与实例
        Object.assign($vm, options);
      }
      $vm.show = true;
    },
  };
};
export default Main;



// WEBPACK FOOTER //
// ./src/common/plugin/message/main.js